import type { enOffers } from "./en.offers";

/** Russian for offers and partners (see `en.offers.ts`); words from the boards. */
export const ruOffers: Record<keyof typeof enOffers, string> = {
  "u6.age.sec": "{n} с",
  "u6.age.min": "{n} мин",
  "u6.age.hours": "{n} ч",
  "u6.age.days": "{n} сут",
  "u6.archive.title": "Отправить «{name}» в архив?",
  "u6.archive.body": "Оффер пропадёт из списка и из выбора в кампаниях. Цифры и конверсии останутся в отчётах.",
  "u6.archive.partnerTitle": "Отправить партнёрку «{name}» в архив?",
  "u6.archive.partnerBody": "Постбеки партнёрки больше не принимаются. Её офферы и цифры останутся в отчётах.",
  "u6.archive.done": "Отправлено в архив",
  "u6.archive.failed": "Не получилось отправить в архив",
  "u6.cap.none": "без капа",
  "u6.cap.reached": "кап исчерпан",
  "u6.card.loading": "Загружаем…",
  "u6.card.loadFailed": "Не удалось открыть оффер",
  "u6.card.edit": "Изменить",
  "u6.card.duplicate": "Дублировать",
  "u6.card.capBadge": "Кап {used} / {limit} сегодня",
  "u6.card.sourced": "ведёт {source}",
  "u6.card.tabs": "Разделы",
  "u6.card.tab.summary": "Сводка",
  "u6.card.tab.campaigns": "Кампании",
  "u6.card.tab.conversions": "Конверсии",
  "u6.card.tab.history": "История",
  "u6.card.meta.partner": "Партнёрка {name}",
  "u6.card.meta.countries": "страны {list}",
  "u6.card.where": "Куда ведёт",
  "u6.card.noLink": "Ссылки нет — оффер только для учёта: трафик на него не уходит",
  "u6.card.how": "Переход",
  "u6.card.how.redirect": "Редирект (ссылка партнёрки)",
  "u6.card.macros": "Метки",
  "u6.card.payout": "Выплата",
  "u6.card.rulesCount": "правила по странам: {n}",
  "u6.card.rules.country": "Страна",
  "u6.card.rules.model": "Модель",
  "u6.card.rules.amount": "Выплата",
  "u6.card.caps": "Кап и лимиты",
  "u6.card.caps.today": "Сегодня по {tz}",
  "u6.card.caps.none": "Кап в день не задан",
  "u6.card.caps.total": "Всего",
  "u6.card.caps.clicks": "Клики в день",
  "u6.card.caps.onCap": "При капе",
  "u6.card.caps.onCap.value": "предупреждение — трафик не останавливается",
  "u6.card.statuses": "Статусы партнёрки",
  "u6.card.statuses.fromPartner": "из настроек партнёрки",
  "u6.card.statuses.none": "Партнёрка ещё не присылала статусов",
  "u6.card.usage": "Где используется",
  "u6.card.usage.none": "За период кампании на этот оффер людей не отправляли",
  "u6.card.usage.campaign": "Кампания",
  "u6.card.trend": "Лиды и апрувы по дням",
  "u6.card.trend.none": "За период лидов нет",
  "u6.card.lastConversions": "Последние конверсии",
  "u6.card.conv.none": "За период конверсий нет",
  "u6.card.conv.at": "Время",
  "u6.card.conv.status": "Статус",
  "u6.card.conv.payout": "Выплата",
  "u6.card.history.none": "Изменений пока не было",
  "u6.col.offer": "Оффер",
  "u6.col.partner": "Партнёрка",
  "u6.col.payout": "Выплата",
  "u6.col.countries": "Страны",
  "u6.col.cap": "Кап сегодня",
  "u6.col.leads": "Лиды",
  "u6.col.approve": "Апрув",
  "u6.col.revenue": "Доход",
  "u6.col.revenueUsd": "Доход, $",
  "u6.col.campaigns": "Кампаний",
  "u6.col.status": "Статус",
  "u6.col.model": "Модель",
  "u6.col.currency": "Валюта",
  "u6.col.postback": "Постбек",
  "u6.col.statuses": "Статусы",
  "u6.col.offers": "Офферов",
  "u6.common.all": "все",
  "u6.common.archive": "В архив",
  "u6.common.cancel": "Отмена",
  "u6.common.loading": "Загружаем…",
  "u6.common.more": "Ещё",
  "u6.common.nothing": "Ничего не нашлось",
  "u6.common.pick": "Выберите…",
  "u6.common.today": "Сегодня",
  "u6.common.yesterday": "Вчера",
  "u6.cur.usd": "доллар США",
  "u6.cur.eur": "евро",
  "u6.cur.rub": "российский рубль",
  "u6.ed.title": "Оффер {name}",
  "u6.ed.titleNew": "Новый оффер",
  "u6.ed.sub": "Новая выплата — для новых конверсий: прошлые не пересчитываются.",
  "u6.ed.subNew": "Черновик сохраняется сам. Оффер появится в кампаниях после «Сохранить».",
  "u6.ed.draft": "черновик",
  "u6.ed.keys": "⌘S — сохранить · Esc — закрыть",
  "u6.ed.save": "Сохранить",
  "u6.ed.saving": "Сохраняем…",
  "u6.ed.saved": "Оффер сохранён",
  "u6.ed.created": "Оффер создан",
  "u6.ed.saveFailed": "Не удалось сохранить",
  "u6.ed.copySuffix": "(копия)",
  "u6.ed.sourced.title": "Этот оффер публикует {source}",
  "u6.ed.sourced.body": "Название, партнёрку, выплату, страны, статус и параметры меняют там — здесь они только для чтения. Ссылку, лимиты и статусы можно менять.",
  "u6.ed.err.title": "Не сохранено: {count} {word}",
  "u6.ed.err.word": "ошибка|ошибки|ошибок",
  "u6.ed.err.url": "адрес ссылки",
  "u6.ed.err.below": "Поля подсвечены ниже.",
  "u6.ed.err.rules": "повтор страны в правилах",
  "u6.ed.err.params": "параметры",
  "u6.ed.err.statuses": "статусы",
  "u6.ed.sectionOk": "без ошибок",
  "u6.ed.sectionErr": "ошибка",
  "u6.ed.expand": "Развернуть",
  "u6.ed.sec.main": "Основное",
  "u6.ed.sec.link": "Ссылка партнёрки",
  "u6.ed.sec.payout": "Выплата",
  "u6.ed.sec.caps": "Лимиты",
  "u6.ed.sec.params": "Параметры для партнёрки",
  "u6.ed.sec.conversions": "Конверсии",
  "u6.ed.name": "Название",
  "u6.ed.name.hint": "видно в кампаниях и отчётах",
  "u6.ed.network": "Партнёрка",
  "u6.ed.network.pick": "Выберите партнёрку",
  "u6.ed.network.search": "Название партнёрки",
  "u6.ed.status": "Статус",
  "u6.ed.countries": "Страны",
  "u6.ed.countries.add": "Добавить страну…",
  "u6.ed.url": "Адрес",
  "u6.ed.url.macros": "Вставить метку:",
  "u6.ed.how": "Как вести",
  "u6.ed.how.redirect": "Редирект",
  "u6.ed.how.link": "Прямая ссылка",
  "u6.ed.model": "Модель",
  "u6.ed.amount": "Выплата",
  "u6.ed.rules": "Своя выплата для страны",
  "u6.ed.rules.rest": "остальные страны — по умолчанию",
  "u6.ed.rules.country": "Страна…",
  "u6.ed.rules.add": "Страна",
  "u6.ed.rules.remove": "Убрать строку",
  "u6.ed.dailyCap": "Лидов в день",
  "u6.ed.totalCap": "Лидов всего",
  "u6.ed.noLimit": "без лимита",
  "u6.ed.tz": "Сутки считать по",
  "u6.ed.onCap": "Когда кап исчерпан",
  "u6.ed.onCap.value": "трекер покажет предупреждение; трафик не останавливается и никуда не переводится",
  "u6.ed.tz.hint": "по умолчанию — часовой пояс рабочего пространства",
  "u6.ed.params.hint": "Добавятся к ссылке как ?ключ=значение",
  "u6.ed.params.key": "ключ",
  "u6.ed.params.value": "значение",
  "u6.ed.params.add": "Параметр",
  "u6.ed.params.remove": "Убрать параметр",
  "u6.ed.goal": "Цель",
  "u6.ed.goal.default": "Как в рабочем пространстве",
  "u6.ed.statuses.inherit": "Статусы берутся из настроек партнёрки {network}: {words}.",
  "u6.ed.statuses.global": "общий словарь трекера",
  "u6.ed.statuses.atPartner": "Изменить у партнёрки",
  "u6.ed.statuses.own": "Своё значение статуса только для этого оффера (необязательно)",
  "u6.ed.statuses.word": "статус у партнёрки",
  "u6.ed.statuses.ours": "у нас",
  "u6.ed.statuses.add": "Статус",
  "u6.ed.statuses.remove": "Убрать статус",
  "u6.ed.sum.caps": "{n} лидов в день",
  "u6.ed.sum.inherit": "статусы партнёрки",
  "u6.ed.sum.statuses": "своих статусов: {n}",
  "u6.empty.title": "Офферов пока нет",
  "u6.empty.body": "Оффер — это то, что вы рекламируете: ссылка партнёрки, выплата и страны, где он работает. Кампания отправляет на него людей с лендов, а трекер считает, сколько он принёс.",
  "u6.empty.step1": "Подключите партнёрку",
  "u6.empty.step1.done": "Партнёрка подключена",
  "u6.empty.step1.sub": "адрес постбека — в её кабинет",
  "u6.empty.step2": "Добавьте оффер",
  "u6.empty.step2.sub": "ссылка партнёрки, выплата, страны",
  "u6.empty.step3": "Соберите кампанию",
  "u6.empty.step3.sub": "источник, ленды, домен — и ссылка готова",
  "u6.empty.add": "Добавить оффер",
  "u6.err.nameRequired": "Без названия не сохранить",
  "u6.err.networkRequired": "Выберите партнёрку",
  "u6.f.add": "Фильтр",
  "u6.f.apply": "Применить",
  "u6.f.reset": "Сбросить",
  "u6.f.back": "Назад",
  "u6.f.clear": "Сбросить все",
  "u6.f.facets": "Фильтры",
  "u6.f.country": "Страна",
  "u6.f.model": "Модель",
  "u6.kpi.clicks": "Клики",
  "u6.kpi.leads": "Лиды",
  "u6.kpi.approved": "Апрувы",
  "u6.kpi.approveShare": "{pct} из решённых",
  "u6.kpi.hold": "В холде",
  "u6.kpi.inTransit": "≈ {sum} в пути",
  "u6.kpi.revenue": "Доход",
  "u6.kpi.cost": "Расход",
  "u6.kpi.profit": "Профит",
  "u6.kpi.roi": "ROI",
  "u6.link.check": "Проверить ссылку",
  "u6.link.again": "Проверить ещё раз",
  "u6.link.checking": "Проверяем…",
  "u6.link.never": "Ссылку ещё не проверяли",
  "u6.link.result": "Проверено {at} — {status} на {host}{hops}, {ms} мс",
  "u6.link.clickOk": "метка клика на месте",
  "u6.link.clickMissing": "нет метки клика — постбеку будет не к чему привязаться",
  "u6.link.err.dns": "Такого адреса нет: домен не находится",
  "u6.link.err.timeout": "Не ответил за 8 секунд",
  "u6.link.err.tls": "Сертификат сайта не проходит проверку",
  "u6.link.err.refused": "Сервер не принимает соединение",
  "u6.link.err.blocked": "Адрес ведёт во внутреннюю сеть — такие не открываем",
  "u6.link.err.badUrl": "Это не адрес: нужен https:// в начале и без пробелов",
  "u6.link.err.http": "Не открылась — ошибка соединения",
  "u6.word.redirects": "редирект|редиректа|редиректов",
  "u6.model.cpa": "за подтверждённый заказ",
  "u6.model.cpl": "за лид",
  "u6.model.cps": "за продажу",
  "u6.model.revshare": "доля от оборота",
  "u6.model.cpc": "за клик",
  "u6.model.cpm": "за тысячу показов",
  "u6.model.cpi": "за установку",
  "u6.model.doi": "за подтверждённую подписку",
  "u6.model.soi": "за подписку",
  "u6.offer.id": "id оффера",
  "u6.offers.title": "Офферы",
  "u6.offers.subtitle": "Что вы рекламируете: ссылка партнёрки, выплата и страны. Цифры — за период сверху.",
  "u6.offers.new": "Новый оффер",
  "u6.offers.search": "Название или id оффера",
  "u6.offers.loadFailed": "Не удалось загрузить офферы",
  "u6.offers.noneMatch": "Под эти условия офферов нет",
  "u6.our.unknown": "—",
  "u6.our.approved": "Апрув",
  "u6.our.hold": "Холд",
  "u6.our.rejected": "Отказ",
  "u6.our.refunded": "Возврат",
  "u6.our.trash": "Треш",
  "u6.partners.title": "Партнёрки",
  "u6.partners.subtitle": "Кто платит за конверсии. Здесь — адрес постбека для партнёрки и как читать её статусы.",
  "u6.partners.new": "Новая партнёрка",
  "u6.partners.search": "Название партнёрки",
  "u6.partners.loadFailed": "Не удалось загрузить партнёрки",
  "u6.partners.none": "Партнёрок под эти условия нет",
  "u6.partners.unmapped": "пришли незнакомые статусы ({n}). Лидов в холде, пока вы не скажете, что это: {leads}.",
  "u6.partners.map": "Сопоставить",
  "u6.partners.totals": "Итого, партнёрок: {n}",
  "u6.partners.words": "{known} из {total}",
  "u6.partners.newWords": "новых: {n}",
  "u6.pb.arrivesShort": "приходит",
  "u6.pb.silentShort": "нет {age}",
  "u6.pb.ago": "{age} назад",
  "u6.pb.arrives": "приходит · {age} назад",
  "u6.pb.silent": "нет {age}",
  "u6.pb.silentNever": "ни одного постбека",
  "u6.pb.none": "не настроен",
  "u6.pbf.all": "Все",
  "u6.pbf.arrives": "Приходит",
  "u6.pbf.silent": "Молчит",
  "u6.pbf.none": "Не настроен",
  "u6.pc.loadFailed": "Не удалось открыть партнёрку",
  "u6.pc.meta": "{model} по умолчанию · выплаты в {currency}, в отчётах — USD по курсу на день лида · офферов: {offers}",
  "u6.pc.openCabinet": "открыть у партнёрки",
  "u6.pc.tab.postback": "Постбек и статусы",
  "u6.pc.tab.offers": "Офферы",
  "u6.pc.tab.postbacks": "Постбеки",
  "u6.pc.address": "Адрес постбека — вставьте его в кабинет {name}",
  "u6.pc.copy": "Копировать",
  "u6.pc.copied": "Адрес скопирован",
  "u6.pc.onCampaignDomain": "Адрес работает на домене любой кампании с офферами этой партнёрки.",
  "u6.pc.ourClick": "наш клик",
  "u6.pc.payoutLine": "{payout} в {currency} → USD по курсу дня",
  "u6.pc.testHint": "Тестовый постбек отправляется из кампании («Ссылки и постбеки») — на ваш тестовый клик.",
  "u6.pc.st.title": "Как читать статусы {name}",
  "u6.pc.st.warn": "Незнакомый статус засчитывается как холд, пока вы его не сопоставите. Сейчас таких лидов: {leads}.",
  "u6.pc.st.none": "Статусов за 30 дней не приходило",
  "u6.pc.st.theirs": "Статус у {name}",
  "u6.pc.st.ours": "У нас",
  "u6.pc.st.leads": "Лидов",
  "u6.pc.st.new": "новый",
  "u6.pc.st.dict": "по словарю",
  "u6.pc.st.saved": "Сохранено. Лиды на новых статусах пересчитаются в течение минуты.",
  "u6.pc.offers": "Офферы {name}",
  "u6.pc.allOffers": "все {n}",
  "u6.pc.noOffers": "У партнёрки нет офферов",
  "u6.pc.lastPostbacks": "Последние постбеки",
  "u6.pc.toJournal": "в журнал",
  "u6.pc.noPostbacks": "За период постбеков нет",
  "u6.pc.pb.at": "Когда",
  "u6.pc.pb.click": "Клик",
  "u6.pc.pb.status": "Статус",
  "u6.pc.pb.result": "Итог",
  "u6.pe.title": "Партнёрка {name}",
  "u6.pe.titleNew": "Новая партнёрка",
  "u6.pe.sub": "Адрес постбека не меняется при сохранении.",
  "u6.pe.saved": "Партнёрка сохранена",
  "u6.pe.created": "Партнёрка создана",
  "u6.pe.sec.main": "Основное",
  "u6.pe.sec.security": "Защита",
  "u6.pe.sec.silence": "Если постбеков нет",
  "u6.pe.currency": "Валюта выплат",
  "u6.pe.model": "Модель по умолчанию",
  "u6.pe.cabinet": "Сайт кабинета",
  "u6.pe.cabinet.hint": "для ссылки «открыть у партнёрки»",
  "u6.pe.click": "Клик",
  "u6.pe.status": "Статус",
  "u6.pe.payout": "Выплата",
  "u6.pe.key": "Ключ в постбеке",
  "u6.pe.key.hint": "задаётся при создании: новый ключ отключил бы адрес в кабинете партнёрки",
  "u6.pe.ips": "Принимать только с IP",
  "u6.pe.ips.hint": "необязательно; адрес или подсеть",
  "u6.pe.ips.any": "любой",
  "u6.pe.silence": "Сообщить, если тишина дольше",
  "u6.pe.silence.hint": "сообщение придёт в «Здоровье данных»",
  "u6.pe.silence.never": "Не сообщать",
  "u6.pe.silence.hours": "{n} ч",
  "u6.pe.silence.days": "{n} дней",
  "u6.status.active": "Работает",
  "u6.status.paused": "Пауза",
  "u6.status.capped": "Кап на сегодня",
  "u6.status.archived": "Архив",
  "u6.totals.page": "Итого по странице",
  "u6.view.label": "Вид",
  "u6.view.active": "Работают",
  "u6.view.capped": "Кап на сегодня",
  "u6.view.silent": "Без лидов 7 дней",
  "u6.view.mine": "Мои",
  "u6.view.archived": "Архив",
  "u6.health.silent": "Партнёрки молчат дольше, чем вы просили: {count}",
  "u6.health.silent.sub": "Постбеков нет — лиды могут ждать у партнёрки. Проверьте адрес в её кабинете.",
  "u6.health.open": "Партнёрки",
};
